import React from 'react';

interface SendMailModalProps {
  show: boolean;
  onClose: () => void;
  handleSendVotingEmail: () => Promise<void>;
}

const SendMailModal: React.FC<SendMailModalProps> = ({
  show,
  onClose,
  handleSendVotingEmail
}) => {
  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex={-1}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Email Sending</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p>Do you really want to send reminder emails to all users who haven't voted yet?</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSendVotingEmail}>
              Yes, send emails
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendMailModal;
